module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/ecomm/ecomm-01-aa30eb4290390dc73243a114394e4c2a.jpg";